<div class="field status">
  <div class="text">{{ 'label.Status' | translate }}:</div>
  <div>{{ 'label.Off' | translate }}:</div>
  <label class="switch">
    <input
      type="checkbox"
      [ngModel]="
        editingCustomer.customerBranding &&
        editingCustomer.customerBranding.isActive
      "
      (ngModelChange)="
        editingCustomer.customerBranding &&
          (editingCustomer.customerBranding.isActive = $event)
      "
      [checked]="editingCustomer.customerBranding.isActive"
    />
    <span class="slider round"></span>
    <hr-field-state-marker
      [field]="fieldStates?.isActive"
    ></hr-field-state-marker
    ><br />
  </label>
  <div>{{ 'label.On' | translate }}:</div>
</div>

<div class="field cover-photo">
  <label class="text"> {{ 'label.ProfileCoverPhoto' | translate }}: </label>
  <input
    type="file"
    ngFileSelect
    [options]="uploadOptions"
    [uploadInput]="upload"
    (uploadOutput)="onUpload($event, imageType.cover)"
  />
  <hr-field-state-marker
    [field]="fieldStates?.coverImage"
  ></hr-field-state-marker
  ><br />

  <div *ngIf="editingCustomer.customerBranding.customerCoverImageUrl != null">
    <a
      target="blank"
      href="{{ editingCustomer.customerBranding.customerCoverImageUrl }}"
      >view</a
    >
  </div>
</div>

<div class="field desktop-img">
  <label class="text"> {{ 'label.BGImageDesktop' | translate }}: </label>
  <input
    type="file"
    ngFileSelect
    [options]="uploadOptions"
    [uploadInput]="upload"
    (uploadOutput)="onUpload($event, imageType.desktop)"
  />
  <hr-field-state-marker
    [field]="fieldStates?.desktopImage"
  ></hr-field-state-marker
  ><br />

  <div
    *ngIf="
      editingCustomer.customerBranding.announcementDesktopBgImageUrl != null
    "
  >
    <a
      target="blank"
      [href]="editingCustomer.customerBranding.announcementDesktopBgImageUrl"
      >view</a
    >
  </div>
</div>

<div class="field mobile-image">
  <label class="text"> {{ 'label.BGImageMobile' | translate }}: </label>
  <input
    type="file"
    ngFileSelect
    [options]="uploadOptions"
    [uploadInput]="upload"
    (uploadOutput)="onUpload($event, imageType.mobile)"
  />
  <hr-field-state-marker
    [field]="fieldStates?.mobileImage"
  ></hr-field-state-marker
  ><br />

  <div
    *ngIf="
      editingCustomer.customerBranding.announcementMobileBgImageUrl != null
    "
  >
    <a
      target="blank"
      href="{{ editingCustomer.customerBranding.announcementMobileBgImageUrl }}"
      >view</a
    >
  </div>
</div>

<div class="field color">
  <label class="text"> {{ 'label.BGColor' | translate }}: </label>
  <div class="color-container">
    <input
      type="text"
      [ngModel]="
        editingCustomer.customerBranding &&
        editingCustomer.customerBranding.announcementDetailsBgColor
      "
      (ngModelChange)="
        editingCustomer.customerBranding &&
          (editingCustomer.customerBranding.announcementDetailsBgColor = $event)
      "
      style="width: 100px; height: 30px"
    />
    <div
      (click)="onColorPicker(colorType.CustomerBackground)"
      class="color-circle"
      [ngStyle]="{
        background: editingCustomer.customerBranding.announcementDetailsBgColor
      }"
    ></div>
  </div>
  <div [ngClass]="{ 'inactive-color-picker': !isColorPickerActive }">
    <p-colorPicker
      [ngModel]="
        editingCustomer.customerBranding &&
        editingCustomer.customerBranding.announcementDetailsBgColor
      "
      (ngModelChange)="
        editingCustomer.customerBranding &&
          (editingCustomer.customerBranding.announcementDetailsBgColor = $event)
      "
      [inline]="true"
    >
    </p-colorPicker>
  </div>
  <hr-field-state-marker [field]="fieldStates?.color"></hr-field-state-marker
  ><br />
</div>
<div>
  <div class="field announcement-list-color">
    <label class="text"> {{ 'label.ListColor' | translate }}: </label>
    <div class="color-container">
      <input
        type="text"
        [ngModel]="
          editingCustomer.customerBranding &&
          editingCustomer.customerBranding.announcementListColor
        "
        (ngModelChange)="
          editingCustomer.customerBranding &&
            (editingCustomer.customerBranding.announcementListColor = $event)
        "
        style="width: 100px; height: 30px"
      />
      <div
        (click)="onColorPicker(colorType.AnnouncementList)"
        class="color-circle"
        [ngStyle]="{
          background: editingCustomer.customerBranding.announcementListColor
        }"
      ></div>
    </div>
    <div
      [ngClass]="{
        'inactive-color-picker': !isAnnouncementListColorPickerActive
      }"
    >
      <p-colorPicker
        [ngModel]="
          editingCustomer.customerBranding &&
          editingCustomer.customerBranding.announcementListColor
        "
        (ngModelChange)="
          editingCustomer.customerBranding &&
            (editingCustomer.customerBranding.announcementListColor = $event)
        "
        [inline]="true"
      >
      </p-colorPicker>
    </div>
    <hr-field-state-marker
      [field]="fieldStates?.listColor"
    ></hr-field-state-marker
    ><br />
  </div>

  <div class="field own-announcements">
    <div class="text">{{ 'label.OwnAnnouncements' | translate }}:</div>
    <label class="switch">
      <input
        type="checkbox"
        [ngModel]="
          editingCustomer.customerBranding &&
          editingCustomer.customerBranding.isWithOwnAnnouncement
        "
        (ngModelChange)="
          editingCustomer.customerBranding &&
            (editingCustomer.customerBranding.isWithOwnAnnouncement = $event)
        "
        [checked]="editingCustomer.customerBranding.isWithOwnAnnouncement"
      />
      <span class="slider round"></span>
    </label>
  </div>

  <div class="button-container">
    <div>
      <button (click)="onSaveClick()">{{ 'label.Save' | translate }}</button>
    </div>
    <div>
      <button (click)="onCancelClick()">
        {{ 'label.Cancel' | translate }}
      </button>
    </div>
  </div>
</div>
